var moduleMap = {
	".": () => {
		return Promise.all([__webpack_require__.e(710), __webpack_require__.e(692), __webpack_require__.e(524), __webpack_require__.e(538), __webpack_require__.e(3), __webpack_require__.e(43), __webpack_require__.e(77), __webpack_require__.e(391), __webpack_require__.e(536), __webpack_require__.e(953), __webpack_require__.e(179), __webpack_require__.e(674), __webpack_require__.e(74), __webpack_require__.e(158), __webpack_require__.e(646), __webpack_require__.e(97), __webpack_require__.e(898), __webpack_require__.e(461), __webpack_require__.e(624), __webpack_require__.e(537), __webpack_require__.e(292), __webpack_require__.e(697), __webpack_require__.e(192), __webpack_require__.e(845), __webpack_require__.e(11), __webpack_require__.e(545), __webpack_require__.e(920), __webpack_require__.e(866), __webpack_require__.e(700), __webpack_require__.e(425), __webpack_require__.e(672), __webpack_require__.e(902), __webpack_require__.e(329), __webpack_require__.e(76)]).then(() => (() => ((__webpack_require__(99076)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});